import { createSelector } from 'reselect';
import HandoverRegistrationAtOriginColumns from '../../containers/HandoverRegistrationAtOriginColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.HANDOVER_REGISTRATION_AT_ORIGIN.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.HANDOVER_REGISTRATION_AT_ORIGIN.isLoading;

export const getData =
  ReportDefinitions.HANDOVER_REGISTRATION_AT_ORIGIN.getDataFunction();

export const getColumns =
  createSelector(getData, HandoverRegistrationAtOriginColumns);
